export default "__VITE_ASSET__DCmEfvDQ__"